<!-- 系统映射关系 -->
<template>
  <div class="mappingData">
    <vxe-toolbar size="mini" v-if="isEdit">
      <template v-slot:buttons>
        <!-- <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="editEvent()"
        >修改</vxe-button> -->
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="matchEvent()"
          >匹配</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      resizable
      show-overflow
      :span-method="rowspanMethod"
      :data="tableData"
      size="mini"
      ref="dataMappingTable"
      :edit-config="editConfig"
      auto-resize
    >
      <vxe-table-column field="onedataType" title="中台类别" min-width="150"></vxe-table-column>
      <vxe-table-column
        field="onedataTypeValue"
        title="中台类别值"
        min-width="150"
      ></vxe-table-column>
      <vxe-table-column field="mapSystemName" title="映射系统" min-width="150"></vxe-table-column>
      <vxe-table-column field="mapTypeName" title="映射类别" min-width="150"></vxe-table-column>
      <vxe-table-column
        field="mapTypeValue"
        title="映射类别值"
        min-width="150"
        :edit-render="{ name: 'input', attrs: { type: 'text' } }"
      ></vxe-table-column>
    </vxe-table>
    <vxe-table
      border
      resizable
      show-overflow
      :data="callLogsDatalist"
      size="mini"
      ref="dataMappingTable"
      auto-resize
      v-if="isEdit"
      style="margin-top: 20px"
    >
      <vxe-table-column type="seq" title="序号" min-width="150"></vxe-table-column>
      <vxe-table-column field="gmtCreate" title="操作时间" min-width="150"></vxe-table-column>
      <vxe-table-column field="status" title="状态" min-width="150">
        <template v-slot="{ row }">
          {{ row.status == 0 ? '成功' : '失败' }}
        </template>
      </vxe-table-column>
      <vxe-table-column field="errorReason" title="失败原因" min-width="150"></vxe-table-column>
    </vxe-table>

    <el-dialog title="匹配MGD仓库" :visible.sync="dialogVisible" width="80%" @close="close">
      <div class="main-content">
        <sirui-table
          :rowKey="'STORAGE'"
          ref="siruiTable"
          :data="tableDataMDG"
          @dblclickEvent="dblclickEvent"
        >
          <vxe-table-column type="radio" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :type="item.type"
            :fixed="item.fixed"
            :field="item.prop"
            :title="item.label"
            :width="item.width || '120'"
            :sortable="item.sortable"
          >
          </vxe-table-column>
        </sirui-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">{{ $t('dialog.cancel') }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{ $t('dialog.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import API from '@/api/masterData/company.js';
  import SiruiTable from '@/components/SiruiTable';
  import XEUtils from 'xe-utils';
  export default {
    name: 'mappingData',
    props: ['callLogsData', 'isEdit', 'detailInfo'],
    components: {
      SiruiTable,
    },
    data() {
      return {
        editConfig: {},
        tableData: [],
        tableDataMDG: [],
        callLogsDatalist: [],
        mapTypeList: [{ value: 'ZMDG_DE_CKID', label: 'MDG仓库编码' }],
        dialogVisible: false,
        columnList: [
          {
            prop: 'STORAGE',
            label: 'MDG仓库编码',
          },
          {
            prop: 'CKMC',
            label: '仓库名称',
          },
          {
            prop: 'CKDZ',
            label: '仓库地址',
          },
          {
            prop: 'CKLX_TXT',
            label: '仓库类型',
          },
          {
            prop: 'SCOPE',
            label: '匹配度',
          },
        ],
      };
    },
    watch: {
      callLogsData(val) {
        this.callLogsDatalist = val;
      },
    },
    mounted() {
      this.editConfig = !this.isEdit ? {} : { trigger: 'click', mode: 'row' };
    },
    methods: {
      initData(data) {
        this.tableData = data;
        if (!data || !data[0]) return;
        this.tableData.map((item) => {
          item['mapTypeName'] = this.mapTypeList.find((it) => it.value == item.mapType).label;
        });
      },
      matchEvent() {
        let params = XEUtils.clone(this.detailInfo, true);
        delete params.mdgSystemMap;
        delete params.storageCreateTime;
        delete params.gmtModified;
        this.$axios.post(API.CHECK_MDG_WAREHOUSE, params).then((res) => {
          if (res.data.code === 0) {
            this.tableDataMDG = res.data.data.mdgResult.RT_RESULT;
            if (this.tableDataMDG[0]) {
              this.dialogVisible = true;
            } else {
              this.$message({ showClose: true, message: '没有匹配的数据', type: 'error' });
            }
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      dblclickEvent(val) {
        console.log(val.row);
        this.$refs.siruiTable.setRadioRow(val.row, true);
      },
      close() {
        this.dialogVisible = false;
      },
      handleConfirm() {
        let obj = this.$refs.siruiTable.getRadioRecord();
        if (!obj) {
          this.$message({ showClose: true, message: '请选中需要匹配的数据', type: 'error' });
        }
        this.dialogVisible = false;
        console.log(obj);
        let row = {
          id: this.detailInfo.mdgSystemMap?.id,
          onedataType: '仓库编码', //中台类别
          onedataTypeValue: this.detailInfo.storageCode, //中台类别值
          mapSystemName: 'MDG', //映射系统
          mapType: 'ZMDG_DE_CKID', //映射类别
          mapTypeName: 'MDG仓库编码', //映射类别
          mapTypeValue: obj.STORAGE, //映射类别值
        };
        row = this.$baseRequest.assignObj(row);
        this.tableData = [row];
      },
      // 通用行合并函数（将相同多列数据合并为一行）
      rowspanMethod({ row, $rowIndex, column, data }) {
        const fields = ['onedataType', 'onedataTypeValue'];
        const cellValue = XEUtils.get(row, column.property);
        if (cellValue && fields.includes(column.property)) {
          const prevRow = data[$rowIndex - 1];
          let nextRow = data[$rowIndex + 1];
          if (prevRow && XEUtils.get(prevRow, column.property) === cellValue) {
            return { rowspan: 0, colspan: 0 };
          } else {
            let countRowspan = 1;
            while (nextRow && XEUtils.get(nextRow, column.property) === cellValue) {
              nextRow = data[++countRowspan + $rowIndex];
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 };
            }
          }
        }
      },
    },
  };
</script>

<style scoped></style>
